import Axios from "axios";
import Qs from "qs";
import { isMoblie } from "@/assets/js/until";
import { Message } from "element-ui";
const axios = Axios.create({
  timeout: 10000,
});

// 把用户参数添加到config的方法 返回config里面的参数
function addUserInfo(config, target) {
  //  target：params 或 data
  // 在这里处理你需要增加的用户参数
  if (!target) {
    throw "addUserInfo 必须有config参数";
  }
  if (!target) {
    throw "addUserInfo 必须有target参数";
  }
  /**
   * 例如:想添加open_appid在请求参数上
   * config[target].open_appid = window.vm.$root.$data.open_appid; 从根节点上取open_appid
   * 例如:想添加token在请求头上
   * config.headers.token =  window.vm.$root.$data.access_token
   */
  config.headers.token =
    window.$getCookie("token") || window.vm.$root.$data.token;

  config.headers.appId = process.env.VUE_APP_ENV == "prod" ? 328505 : 328505;
  // config.headers.authorization = "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiI2Mjc5ZTUzNWI3YzRjZDAwMDZmZmU2ZjgiLCJ0eXBlIjoid2ViIiwiY3JlYXRlZCI6MTY1NTcwMjk4NzgyNywiYXBwSWQiOjMyNjMwNSwiZXhwIjoxNjU2MzA3Nzg3fQ.dehS7WMdkhnQm35V1v4_r_ONeZpsmUBQFTP1ISIbhs8wg0X-4vHNo824gsZISmYlABXWhWvEdZKKpXflIOS6fA"
  return {
    ...config[target],
  };
}
window.callBacks = [];
// 转表单
// config [object] axios的promise对象
function toFromData(config) {
  config.headers["Content-Type"] = "application/json";
  config.headers.token =
    window.$getCookie("token") || window.vm.$root.$data.token;
  let formData = new FormData();
  Object.keys(config.data).map((key) => {
    formData.append(key, config.data[key]);
  });
  config.data = formData;
  return config;
}
// 拦截器
axios.interceptors.request.use(
  function (config) {
    // 区分post和get/delete方法 合成对应签名对象
    if (config.method === "post") {
      // 如果是body提交
      if (config.toJSON) {
        // body提交
        config.headers["Content-Type"] = "application/json";
        config.data = JSON.stringify(config.data);
        // 其他参数表单提交
        config.params = {};
        // 赋值签名参数
        addUserInfo(config, "params");

        delete config.toJSON; //删掉toJSON字段
        return config;
      } else if (config.pure) {
        //纯粹的请求，不添加任何参数
        // config.data
        // addUserInfo( config, 'data' )
        return toFromData(config);
      } else {
        if (!config.data) {
          config.data = {};
        }
        // 普通post提交
        // 赋值签名参数
        addUserInfo(config, "data");
        return toFromData(config);
      }
    } else {
      if (!config.params) {
        config.params = {};
      }
      // 其他方式提交
      // 赋值签名参数
      addUserInfo(config, "params");
      return config;
    }
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
axios.interceptors.response.use(
  function (response) {
    let url = window.location.href;
    if (
      url.indexOf("health-archive") == -1 &&
      url.indexOf("body-report/list") == -1 &&
      url.indexOf("body-report/detail") == -1
    ) {
      if (response.data.code === 601 && !isMoblie()) {
        // toke失效，返回登录页
        window.vm.$router.replace({
          path: "/login",
          query: {
            // redirect: window.location.href
            // redirect: "/#/home",
          },
        });
        return response.data;
      }
    }
    // if (response.data.code != 1 && response.data.code != 200) {
    //     Message({
    //         message: response.data.msg,
    //         type: 'error',
    //         duration: 3 * 1000
    //     })
    // }
    return response.data;
  },
  function (error) {
    // Do something with response error
    return Promise.reject(error);
  }
);

export default axios;
